var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function () {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function (selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " + extraClasses + "'></div>");
	}
}

site.extras = {};
site.extras.initDone = false;
/*
 Extras
 */
site.extras.upload =  {
	init: function(urls, lang) {
		if(site.extras.initDone === false) {
			site.extras.initDone = true;
			$('ul#images').sortable({
				'opacity': 0.8,
				'update': function (e, ui) {
					var $el = $(this);
					$el.sortable('disable').addClass('disabled');
					$.post(urls.sort, $(this).sortable('serialize'), function (d) {
						if (d.success !== true) {
							moya.message.add(lang.galleryErrorOnSave);
							$el.sortable('cancel');
						}
						$el.removeClass('disabled');
						$el.sortable('enable');
					});
				}
			});
			$('#ffile').uploadify({
				'uploader': '/_moya/js/jquery/uploadify/uploadify.swf',
				'script': urls.script,
				'cancelImg': '/_moya/js/jquery/uploadify/cancel.png',
				'auto': true,
				'multi': true,
				'folder': '/tmp',
				'fileDesc': lang.galleryImageUploadFileDescription,
				'fileExt': '*.jpg;*.jpeg;*.gif;*.png;*.JPG;*.JPEG;*.GIF;*.PNG',
				'buttonText': lang.galleryImageAdd,
				'queueID': 'ffileQueue',
				'onError': function () {
					$('#notice').html('<div class="message"><div class="error">' + lang.galleryErrorOnSave + '</div></div>');
				},
				'onComplete': function (e, q, f, r) {
					var n = $('#notice');
					switch (r) {
						case 'noAlbum':
							n.html('<div class="message"><div class="error">' + lang.galleryErrorNoAlbumName + '</div></div>');
							break;
						case 'noSave':
							n.html('<div class="message"><div class="error">' + lang.galleryErrorOnSave + '</div></div>');
							break;
					}
				},
				'onAllComplete': function () {
					window.location.reload();
				}
			});
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function (id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.header = {
	init: function () {
		var body = $('body');
		$(window).scroll(function (e) {
			scrollPos = $(this).scrollTop();
			if (scrollPos > 79) {
				body.addClass('stickyHead');
			}
			else {
				body.removeClass('stickyHead');
			}
		});
	}
};

site.nav = {
	// Init navigation scripts
	init: function () {
		// Add expand link to mobile menu
		$('.children', '#mainmenu ').prepend('<span class="expand" href="#"><i class="fa fa-angle-down"></span>');
		$('.selectedLevel1', '#mainmenu').addClass('down');
		$('.selectedLevel2', '#mainmenu').addClass('down');

		var $menu = $('#mainmenu');

		if ($('body').width() > 991) {
			$menu.find('.level1.children > a').click(function (e) {
				$this = $(this).parent();
				if (!$this.hasClass('hover')) {
					$menu.find('.hover').removeClass('hover');
					$this.addClass('hover');
					$('body').addClass('ddOpen');
					site.search.close();
				}
				else {
					$menu.find('.hover').removeClass('hover');
					$('body').removeClass('ddOpen');
				}
				$('body.ddOpen').on('click', function (e) {
					if (!$(e.target).parents('#mainmenu').length) {
						$menu.find('.hover').removeClass('hover');
						$('body').removeClass('ddOpen');
					}
				});
				e.preventDefault();
			});
		}

		site.nav.bind();
	},
	bind: function () {
		// Mobile menu toggle
		$('#mainmenuToggle').click(function (e) {
			var menuOpen = $('body').hasClass('mainmenu-open');
			if (!menuOpen) {
				site.window.scrollPosition = $(window).scrollTop();
			}
			site.nav.mobileToggle(e, menuOpen, site.window.scrollPosition);

			e.preventDefault();
		});

		// Expand in mobile menu
		$('.expand', '#mainmenu').bind('click', function (e) {
			e.preventDefault();
			$(this).closest('li').toggleClass('down');
		});
	},
	// Toggle mobile menu
	mobileToggle: function (e, menuOpen, scrollPosition) {
		$('body').toggleClass('mainmenu-open');
		$(this).toggleClass('open');
		if (!menuOpen) {
			$(window).scrollTop(0);
			$('i', '#mainmenuToggle').removeClass('fa-bars').addClass('fa-close');
		}
		else {
			$(window).scrollTop(scrollPosition);
			$('i', '#mainmenuToggle').removeClass('fa-close').addClass('fa-bars');
		}
	},
	// Append language to mobilemenu
	appendLanguage: function () {
		var $divisions = $('.menu', '#divisions');
		var $menu = $('ul.mmLevel1', '#mainmenu');

		var $html = $('<li class="ele-language si level1"></li>');
		$divisions.find('li').each(function () {
			var $li = $(this).clone();
			$html.append($li.find('a'));
		});

		$menu.append($html);
	}
};

site.frontpage = {
	init: function () {
		if ($('body').hasClass('frontpage')) {
			site.owl.init('#owl-hero', {
				nav: true,
				dots: false,
				autoplay:true,
				loop:true,
				autoplayTimeout:8000,
				navText: ["", ""],
				items: 1
			});
		}
	}
};

site.footer = {
	init: function () {
		$fbox = $('#footerInfo #hero');
		$fbox.find('li').click(function (e) {
			location.href = $(this).find('a.btn').attr('href');
		});
	}
};

site.search = {
	init: function () {
		var $toggle = $('#searchDrop');
		var $box = $('#searchBox');
		$toggle.click(function (e) {
			e.preventDefault();
			var $body = $('body');
			$body.toggleClass('search-open');

			$('body.search-open').on('click', function (e) {
				if (!$(e.target).parents('#pageContainer .searchWrap').length) {
					$('body').removeClass('search-open');
				}
			});
			$box.find('#q').focus();
		})
	},
	close: function () {
		$('body').removeClass('search-open');
	}
};

site.maps = {
	init: function () {
		var $mapMenu = $('#mapCats');
		$mapMenu.find('.catTitle').click(function () {
			$mapMenu.find('.menu').toggle();
		});
	}
};
site.store = {
	init: function () {
		site.store.makeGreen();
		if ($('body').hasClass('category')) {
			site.store.filter();
			site.store.compare();
		}
		if ($('body').hasClass('product')) {
			site.store.product();
		}
		$('body').on('click', '#compareFilter:not(.disabled) .filterTitle', function (e) {
			e.preventDefault();
			$('body').toggleClass('compare-open');

			$('body.compare-open').on('click', function (e) {
				if (!$(e.target).parents('#compareFilter').length) {
					$('body').removeClass('compare-open');
				}
			});
		});
		$('body').on('click', '#storeCart .miniCart', function (e) {
			e.preventDefault();
			$('body').toggleClass('cart-open');

			$('body.cart-open').on('click', function (e) {
				if (!$(e.target).parents('#storeCart').length) {
					$('body').removeClass('cart-open');
				}
			});
		});
	},
	filter: function () {
		var $filter = $('#filters');
		//var $filterDropdown = $filter.find('.filter.DropDown');
		site.store.filterCategory();
		site.store.filterCreateDropdown();
		site.store.filterCreateTitle();
		site.store.filterDropdownClick();
		site.store.filterCheckbox();

		// Open material info
		$('#materialInfo i').click(function (e) {
			$('#materialInfo,#materialInfo .materialWrap').toggleClass('open');
		});

		// responsive Img after form change
		/*
		 if($('#store .categoryProducts').on('changed')) {
		 setTimeout(function(){
		 $('#store .image img').responsiveImg();
		 }, 301);
		 }*/
		/*
		 $(document).bind("DOMSubtreeModified",function(){
		 $('#store .image img').responsiveImg();
		 })*/
	},
	filterCheckbox: function () {
		$checkboxes = $('#filters .filter.Checkbox');
		//$checkboxes.find('input').prop('checked').parent().addClass('selected');
		$checkboxes.find('input').on('change', function () {
			site.store.filterMarkCheckbox($(this));
		});
		$checkboxes.find('input').each(function () {
			site.store.filterMarkCheckbox($(this));
		});
	},
	filterMarkCheckbox: function ($e) {
		if ($e.is(':checked')) {
			$e.parent().addClass('selected');
		}
		else {
			$e.parent().removeClass('selected');
		}
	},
	filterCategory: function () {
		// Category dropdown
		var $cats = $('#rootCatFilter');
		var $catsLabel = $cats.find('.filterTitle');
		var $rs = $cats.find('.selected').html();
		$catsLabel.html($rs);
	},
	filterCreateTitle: function () {
		$('#filters .filter.DropDown').each(function () {
			$this = $(this);
			$this.find('.wrap').prepend('<div class="filterTitle"><a href="#"></a></div>');
			var catsLabel = $this.find('.filterTitle a');
			var rs = $this.find('select option:selected').text();
			catsLabel.html(rs);
		});
	},
	filterCreateDropdown: function () {
		$('#filters .filter.DropDown').each(function () {
			$this = $(this);

			var selected = 0;
			var $class = '';
			var $select = $this.find('select');
			$ul = $('<ul></ul>').attr('id', $select.attr('id'))
				.attr('class', 'menu');
			selected = $select[0].selectedIndex;

			$select.children().each(function (i) {
				var $option = $(this);
				$('<li></li>').attr('class', $option.val())
					.html('<a href="filter-' + $option.val() + '">' + $option.text() + '</a>')
					//.html($option.text())
					.appendTo($ul);
			});
			$ul.find('li:eq(' + selected + ')').addClass('selected');
			$this.find('.wrap').append($ul).wrapInner('<div class="dd" />');
		});
	},
	filterDropdownClick: function () {
		// Category dropdown
		$('body').on('click', '#rootCatFilter .filterTitle', function (e) {
			e.preventDefault();
			$('body').toggleClass('filter-open');

			var $parent = $('#rootCatFilter');
			$parent.toggleClass('open');

			$('body.filter-open').on('click', function (e) {
				if (!$(e.target).parents('#rootCatFilter').length) {
					$('body').removeClass('filter-open');
					$parent.removeClass('open');
				}
			});
		});

		// Filter dropdown
		$('body').on('click', '#filters .DropDown:first .filterTitle', function (e) {
			e.preventDefault();
			$('body').toggleClass('filter-open-first');

			var $parent = $('#filters .DropDown:first')
			$parent.toggleClass('open');

			$('body.filter-open-first').on('click', function (e) {
				if($(e.target).parents('.filter').index() !== $parent.index()) {
					$('body').removeClass('filter-open-first');
					$parent.removeClass('open');
				}
			});
		});
		$('body').on('click', '#filters .DropDown:last .filterTitle', function (e) {
			e.preventDefault();
			$('body').toggleClass('filter-open-last');

			var $parent = $('#filters .DropDown:last')
			$parent.toggleClass('open');

			$('body.filter-open-last').on('click', function (e) {
				if($(e.target).parents('.filter').index() !== $parent.index()) {
					$('body').removeClass('filter-open-last');
					$parent.removeClass('open');
				}
			});
		});

		var $cats = $('#filters .filter');
		var $catsLabel = $cats.find('.filterTitle');
		/*
		 $catsLabel.click(function (e) {
		 var $this = $(this);
		 var $parent = $this.parents('.filter');
		 if (!$parent.hasClass('open')) {
		 $parent.removeClass('open');
		 $('#filters .filter').removeClass('open');
		 }
		 $parent.toggleClass('open');
		 e.preventDefault();

		 });*/
		$cats.find('.menu a').click(function (e) {
			$this = $(this);
			var $filter = $this.parents('.filter');
			var $parent = $this.parent();
			var index = $parent.index();
			var $select = $filter.find('.dd').find('select');
			$select[0].selectedIndex = index;
			$select.trigger('change');
			$filter.removeClass('open');

			//Change selected and title
			$filter.find('.filterTitle').html($parent.html());
			$filter.find('.menu li').removeClass('selected');
			$parent.addClass('selected');

			e.preventDefault();
		});
	},
	product: function () {
		$('#store .moreDesc').click(function (e) {
			$(this).parent().toggleClass('open');
		});
		$('#store .lessDesc').click(function (e) {
			$parent = $(this).parents('.productDesc');
			if($parent.hasClass('open')) {
				$parent.toggleClass('open');
				$('html,body').animate({
					scrollTop: $parent.offset().top - 80
				});
			}
			else {
				$parent.toggleClass('open');
			}
		});
		if ($('.product .albumImages li').length > 1) {
			site.store.albumImages();
		}
		$('#store table').addClass('table');
		$('.toggleButtons span.toggle').click(function(e) {
			$this = $(this);
			var id = $this.attr('rel');
			var $parent = $(".extraContentSection[rel=\'"+id+"\']");

			if(!$parent.hasClass('open')) {
				$('.longDesc .extraContentSection').removeClass('open');
				$('.toggleButtons span.toggle').removeClass('open');
				$parent.toggleClass('open');
				$this.toggleClass('open');
				if($('.extraDesc1')) {
					$('html,body').animate({
						scrollTop: $('.extraDesc1').offset().top - 160
					});
				}
			}
			else {
				$parent.toggleClass('open');
				$this.toggleClass('open');
			}

		});
	},
	albumImages: function () {
		var $albumLink = $('ul.albumImages a');
		$albumLink.removeClass('fancybox');
		$albumLink.click(function (e) {
			e.preventDefault();
			$this = $(this);
			$albumLink.parent().removeClass('selected');
			$this.parent().addClass('selected');
			$href = $this.attr('href');
			$src = $this.find('img').attr('src');
			$label = $this.next().text();
			$image = $('.images .image');

			if ($src != $('img', $image).attr('src')) {
				$image.append('<div class="loading">')
				$('a', $image).attr("href", $href);
				$image.find('.imgLabel').text($label);
				$('img', $image).attr("src", $src).load(function () {
					$('.loading', $image).remove();
				});
			}
		});
		/*
		 site.owl.init('.product .albumImages', {
		 loop: false,
		 dots: false,
		 nav: true,
		 items: 4,
		 navText: ["", ""],
		 margin: 10
		 });
		 */
	},
	_makeGreen: function($elements) {
		$elements.each(function() {
			var $this = $(this);
			var html = $this.html().replace(/SÆPLAST/g, '<span class="sp">SÆPLAST</span>');
			$this.html(html);

		});
	},
	makeGreen: function () {
		var $title = $('#main .boxTitle h1');
		this._makeGreen($title);
		var $compareTitle = $('#storeCompareWrapper thead .link a');
		this._makeGreen($compareTitle);
	},
	compareImgFix: function() {
		$('#storeCompareWrapper img').responsiveImg();
	},
	compare: function () {
		const $body = $('body');
		$body.on('click', 'a.storeCompare', function (e) {
			let $this = $(this);
			e.preventDefault();
			let url = $this.attr('href');
			let productId = url.split('/').pop();
			let isAdd = $this.hasClass('add');
			let isTiny = $this.hasClass('tiny');

			$.ajax({
				url: url,
				type: 'get',
				success: function (r) {
					if (r.success) {
						site.store.updateCompareList();

						if (isTiny) {
							site.store.toggleCompareButton($('.storeCompare', '#product_' + productId));
						}
						else {
							site.store.toggleCompareButton($this);
						}
					}
				},
			});
		});
		$body.on('click', 'a.compareClear', function (e) {
			e.preventDefault();
			console.log('compare');

			$.ajax({
				url: $(this).attr('data-url'),
				type: 'get',
				success: function (r) {
					site.store.updateCompareList();
					$('.storeCompare.remove').each(function () {
						site.store.toggleCompareButton($(this));
					});
				},
			});
		});
	},

	toggleCompareButton: function ($elm) {
		if (!$elm.length) {
			return;
		}
		if ($elm.hasClass('add')) {
			$elm.removeClass('add').addClass('remove');
			$elm.attr('href', $elm.attr('data-remove-url'));
			$('span', $elm).text($elm.attr('data-remove-label'));
		}
		else {
			$elm.removeClass('remove').addClass('add');
			$elm.attr('href', $elm.attr('data-add-url'));
			$('span', $elm).text($elm.attr('data-add-label'));
		}
	},

	updateCompareList: function (url) {
		const compareListUpdate = $('#compareFilter').attr('data-url');
		if (compareListUpdate) {
			$.ajax({
				url: compareListUpdate,
				type: 'get',
				success: function (r) {
					let $menu = $('#compareFilter > .menu');
					$menu.empty();
					$menu.append(r);
					let length = $('li', $(r)).length;
					$('.filterTitle .number').text(length);
					if (length) {
						$('#compareFilter').removeClass('disabled');
					}
					else {
						$('#compareFilter').addClass('disabled');
					}
				},
			});
		}
	},
};

site.country = {
	set: function() {
		var country = $.cookie('saeplastCountry');
		if(country) {
			$('#header .langFrom .from').text(country);
		}
	},
	add: function() {
		var $dialog = $('#warehouse__dialog');
		$dialog.find('a').click(function(e) {
			var $country = $(this);
			$.cookie('saeplastCountry', $country.text(), {expires: 365, domain: '.saeplast.com'});
		});
	}
};
site.dialog = {
	create: function (message) {
		if ($('#warehouse__dialog').length) {
			site.dialog.destroy();
		}
		$('body').append('<div id="warehouse__dialog"><div class="dialog__message">' + message + '</div></div><script type="text/javascript">$(function() {site.country.add();});</script>');
		site.dialog.show();
	},
	destroy: function () {
		$('#warehouse__dialog').remove();
	},
	show: function () {
		$("#warehouse__dialog").dialog({
			modal: true,
			dialogClass: 'swh',
			closeOnEscape: false,
			closeText: "hide",
			width: 'auto'
		});
	}
};

site.divisions = {
	fix: function() {
		$('#divisions li.is a').attr('href','http://dalvik.promens.is').attr('target','_blank');
	}
};

// Run all the inits \o/
$(function () {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});
	site.nav.init();
	site.header.init();
	site.frontpage.init();
	site.footer.init();
	site.search.init();
	site.maps.init();
	site.store.init();
	site.country.set();
	site.divisions.fix();
	/*
	 site.owl.init('#reviews > ul', {
	 loop:true,
	 nav:true,
	 navText:["",""],
	 items: 1
	 });*/


	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
		$('#main .boxText table.table1').addClass('table');
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:100%"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Touch login
	$('.login').bind('click', function (e) {
		e.preventDefault();
		window.location = '/moya';
	});


	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});

store = window.store || {};
store.local = store.local || {};

store.local.onUpdateVariantData = function(variant) {
	var attributes = '';
	$.each(variant.attributes, function(attrIdx, attr) {
		attributes += attr + ' / ';
	});
	attributes = attributes.substr(0, attributes.length - 3);

	$('.product .attributes').html(attributes);
};

store.local.updateMiniCart = function () {
	$.get(store.url(store.action.cartMedium, ''), function (data) {
		$('.cartBoxMedium').replaceWith(data.html);
	}, 'json');
	$.get(store.url(store.action.cartBox, ''), function (data) {
		$('.miniCart').replaceWith(data.html);
	}, 'json');
};

store.local.onAddToCart = function () {
	$('body').removeClass('emptyCart');
	store.local.updateMiniCart();
};

store.local.onCartIncrease = function () {
	store.local.updateMiniCart();
};

store.local.onCartDecrease = function () {
	store.local.updateMiniCart();
};
